<div class="row flex-grow-1">
    <div class="col-6">
        
        <div class="card search-card h-70">
            <div class="card-body">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon3">Log Message</span>
                    </div>
                    <input [disabled]="isSnapShot()" type="text" class="form-control searchBox1"
                        placeholder="{{getLogPlaceholder()}}" [(ngModel)]="localFilter().logMessage">
                </div>
            </div>
        </div>
    </div>
    @if(categories()?.length){
        <div class="col-2 larger-font">
            <mat-form-field appearance="fill" class="full-width-field">
                <mat-label>Select a category</mat-label>
                <mat-select [(ngModel)]="localFilter().errorCategoryId">
                    <mat-option *ngFor="let category of categories()" [value]="category.errorCategoryId">
                        {{category.categoryName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-2 larger-font">
            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>Number Of Days To Pull:</mat-label>
                <input matInput [(ngModel)]="localFilter().numberOfDays"
                    placeholder="Enter number of days"
                    title="Number of days to pull data for">
            </mat-form-field>
        </div>
        <div class="col-2 h-100">
            <div class="row button-row">
                <button matButton="outlined" class="action-button" (click)="updateFilters()">Filter From
                    Database</button>
            </div>
            <div class="row button-row">
                <button matButton="outlined" class="action-button" (click)="clearFilters()">Clear Grid
                    Filters</button>
            </div>
        </div>
    }
    
    
    
</div>
